import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import fr from 'facet-rest';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const GeneralSavingsOutcomeGeneralParametersStepLayout = ({
  className,
  classes,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const {
    resource,
    onSubmit,
    saving,
    handleChange,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  const endTypeIsRetirement = resource.attr('endType') === 'retirement';
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <TitleSection />
      <MetaField attr="nickname" />
      <MetaField
        attr="endType"
        onChange={(type) => {
          if (type.includes('retirement')) {
            handleChange('endDate', '');
          } else {
            handleChange('retiringClient', '');
          }
        }}
      />
      <MetaField disabled={endTypeIsRetirement} hidden={endTypeIsRetirement} attr="endDate" />
      <MetaField disabled={!endTypeIsRetirement} hidden={!endTypeIsRetirement} attr="retiringClient" />
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

GeneralSavingsOutcomeGeneralParametersStepLayout.defaultProps = {
  className: '',
};

GeneralSavingsOutcomeGeneralParametersStepLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GeneralSavingsOutcomeGeneralParametersStepLayout);
